/**
 * Created by miguel on 22/2/17.
 */
/// <reference path="../documents/DocumentListCell.ts" />
/// <reference path="InvoiceReviewState.ts" />

class InvoiceCell extends DocumentListCell
{
    protected nameLabel:MUILabel = null;
    private nextDocumentLabel:MUILabel = null;

    awakeFromHTML(){
        super.awakeFromHTML();
        this.nameLabel = MUIOutlet(this, "client-name-lbl", "MUILabel");
        // this.nextDocumentLabel = MUIOutlet(this, "next-doc-lbl", "MUILabel");
    }

    setItem(item:DBDocument){
        super.setItem(item);
        this.nameLabel.text = (item as LegalEntityDocument).legalEntity?.name;

        if (item instanceof PurchaseInvoice) {
            this.referenceLabel.text = item.externalReference;
        }        

        // this.nextDocumentLabel.text = item.nextDocument?.documentNumber;

        // the number in red while the invoice has no status yet (cells are reused: the style comes off too)
        if (item.status == 0) MUICoreLayerAddStyle(this.documentIDLabel.layer, "alert");
        else MUICoreLayerRemoveStyle(this.documentIDLabel.layer, "alert");

        // the stripe at the left: red while the invoice is being prepared, yellow in the review states, none once processed
        InvoiceReviewStateHelper.applyStripeToCell(this.layer as HTMLElement, InvoiceReviewStateHelper.stateForInvoice(item as Invoice));
    }    

}
